import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { BackupService, BackupContext, BackupStatus } from '@c4/core';
import { CORE_STORE } from '@c4/core';

@Component({
  selector: 'prg-backup-project',
  templateUrl: './backup-project.component.html',
  styleUrls: ['./backup-project.component.less']
})
export class BackupProjectComponent implements OnInit {

  required: Observable<boolean>;
  checked: Observable<boolean>;
  running: Observable<boolean>;
  current: Observable<any>;
  previous: Observable<any>;
  last: Observable<any>;
  error: Observable<any>;

  dayOfWeek: string;
  scheduleBackups: boolean;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    private store: Store<{ backup: BackupContext }>,
    private backups: BackupService
  ) {
    this.dayOfWeek = 'sun';
    this.scheduleBackups = false;

    this.required = this.backups.required;
    this.checked = this.backups.checked;
    this.running = this.backups.running;
    this.previous = this.backups.previousOperation;
    this.current = this.backups.currentOperation;
    this.last = this.backups.lastBackup;
    this.error = this.backups.error;
  }

  ngOnInit() {
    this.route.params.take(1).subscribe((params: any) => {
      console.log('backup-project: route params are', params);
      if (!!params.origin) {
        this.backups.setRedirectURL(decodeURI(params.origin));
      }
    })
  }

  startBackup() {
    console.log('start backup with', this.scheduleBackups, this.dayOfWeek);
    this.backups.setBackup('');
  }
}



// WEBPACK FOOTER //
// ./src/app/backup/backup-project.component.ts